<template>
  <div class="main">
    <div class="main_r">
      <div class="dobule">
        <!-- 选择角色 -->
        <div class="dobule_l">
          <div class="title">选择角色</div>
          <ul class="addRole">
            <li  v-for="(item, index) in choseSole" :key="index">
              <div class="normal" @click="clickRole(item, index)" :class="{ cur: index == selectIndex }">{{ item.name }}</div>
              <div>
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                  <el-link :underline="false" type="primary" icon="el-icon-edit-outline" class="mr12" @click="clickdialogEdit(item)"></el-link>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                  <el-link :underline="false" type="danger" icon="el-icon-delete" @click="clickdialogDel(item)"></el-link>
                </el-tooltip>
              </div>
            </li>
          </ul>
          <div class="addRole_Btn">
            <el-link type="primary" icon="el-icon-circle-plus-outline" :underline="false" @click="clickdialogAdd()"></el-link>
          </div>
        </div>
        <!-- 选择角色 End -->

        <!-- 权限分配 -->
        <div class="dobule_r">
          <div class="title">权限分配</div>
          <el-tree
          ref="PermissionsTree"
          class="quanxian"
          :data="classificationData"
          show-checkbox
          node-key="id"
          default-expand-all
          highlight-current
          :props="defaultProps">
          </el-tree>
          <div class="mt15">
            <el-button type="primary" @click="SaveRole()" >保 存</el-button>
          </div>
        </div>
        <!-- 权限分配 End -->
      </div>
    </div>

    <!-- 删除 -->
    <el-dialog title="操作确认" :visible.sync="dialogDel" width="20%" class="confirmDel">
      <div class="confirmMsg">确定删除？</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteRole()" >确 认</el-button>
        <el-button @click="dialogDel = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 删除 End -->

    <!-- 添加角色 -->
    <el-dialog title="添加角色" :visible.sync="dialogAddRole" width="20%" class="confirmDel">
      <div class="confirmMsg">
        <el-input v-model="roleName" placeholder="请输入角色名称"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addRole()" >确 认</el-button>
        <el-button @click="dialogAddRole = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 添加角色 End -->

    <!-- 编辑角色 -->
    <el-dialog title="编辑角色" :visible.sync="dialogEditRole" width="20%" class="confirmDel">
      <div class="confirmMsg">
        <el-input v-model="roleName" placeholder="请输入角色名称"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editRole()" >确 认</el-button>
        <el-button @click="dialogEditRole = false">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 编辑角色 End -->

  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {},
  data () {
    return {
      // 权限分配
      classificationData: [],
      defaultProps: {
        children: 'children',
        label: 'permissionsName'
      },
      // 选择角色
      choseSole: [],
      checkedkeys: [],
      dialogDel: false,
      dialogAddRole: false,
      dialogEditRole: false,
      roleName: '',
      clickRoleId: 0,
      selectIndex: 0
    }
  },
  mounted () {
    this.getPermissionsTree()
    this.listRole()
  },
  methods: {
    clickdialogAdd () {
      this.dialogAddRole = true
      this.roleName = ''
    },
    clickdialogEdit (item) {
      this.dialogEditRole = true
      this.roleName = item.name
      this.clickRoleId = item.id
    },
    clickdialogDel (item) {
      this.dialogDel = true
      this.clickRoleId = item.id
    },
    clickRole (item, index) {
      this.selectIndex = index
      this.clickRoleId = item.id
      this.getRolePermissions()
    },
    SaveRole () {
      this.saveRolePermissions()
    },
    listRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_listRole, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            that.choseSole = response.data.data
            if (that.choseSole.length > 0) {
              that.clickRole(that.choseSole[0], 0)
            }
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    addRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.name = that.roleName
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_addRole, Qs.stringify(data))
        .then(function (response) {
          that.dialogAddRole = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.listRole()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogAddRole = false
        })
    },
    editRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.roleId = that.clickRoleId
      data.name = that.roleName
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_editRole, Qs.stringify(data))
        .then(function (response) {
          that.dialogEditRole = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.listRole()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogEditRole = false
        })
    },
    deleteRole: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.clickRoleId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_deleteRole, Qs.stringify(data))
        .then(function (response) {
          that.dialogDel = false
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.listRole()
          }
        })
        .catch(function (error) {
          console.log(error)
          that.dialogDel = false
        })
    },
    getPermissionsTree: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getPermissionsTree, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.classificationData = response.data.data
          }
          console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    saveRolePermissions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.roleId = that.clickRoleId
      data.checkedKeys = that.$refs.PermissionsTree.getCheckedKeys().toString()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_saveRolePermissions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindAllways(response.data.msg)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getRolePermissions: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.roleId = that.clickRoleId
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_getRolePermissions, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            var checkedkeys = []
            response.data.data.filter((item1, i1) => {
              checkedkeys.push(item1.permissionsId)
            })
            that.$refs.PermissionsTree.setCheckedKeys(checkedkeys)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.dobule{
  display: flex;

  .dobule_l,.dobule_r{
    padding: 20px;
    box-sizing: border-box;
    border-radius: 10px;
  }

  .dobule_l{
    width: 300px;
    flex-shrink: 0;
    margin-right: 20px;
    background: #f6f6fa;
  }

  .dobule_r{
    flex: 1;
    height: 770px;
    background: #f6f6fa;
  }
}

// 选择角色
.addRole{
  li {
    display: flex;
    align-items: center;
    margin-top: 15px;

    & div:nth-child(1){
      width: 200px;
      height: 40px;
      line-height: 40px;
      margin-right: 12px;
      border-radius: 6px;
      box-sizing: border-box;
      padding-left: 15px;
      transition: all .3s;
    }
    & div.normal{
      color: #000;
      background: #fff;
    }

    & div.cur{
      color: #fff;
      background: #4976ff;
    }

    & div:nth-child(2){
      flex: 1;

      .el-link{
        font-size: 16px;
      }
    }
  }
}

.addRole_Btn{
  margin-top: 15px;
  color: #4976ff;

  .el-link{
    font-size: 24px;
  }
}

.confirmDel /deep/ .el-dialog__footer {
  padding: 20px;
  text-align: center;
  border-top: 1px solid #f2f2f2;
}

.confirmDel /deep/ .el-dialog__header {
  padding: 15px 20px 15px;
  background: #f6f6fa;
}
.confirmDel /deep/ .el-dialog__headerbtn {
  top: 20px;
}
.confirmMsg{
  padding: 10px 0 30px 0;
}

// 权限分配
/deep/ .el-tree-node__expand-icon {
  color: #4976ff;
}

/deep/ .el-tree {
  position: relative;
  cursor: default;
  background: none;
  color: #606266;
}

/deep/ .el-tree-node__content {
  height: 32px;
}

.quanxian{
  margin-top: 15px;

  /deep/ .el-tree-node__children .el-tree-node__expand-icon{
    display: none;
  }

  /deep/ .el-tree-node__children .el-checkbox{
    margin-left: 24px;
  }
}

</style>
